import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ActionCommentReply from './action-comment-reply'

const mapStateToProps = (state, { id, match, reply, parentId }) => {
  const action = reply.actions[0]
  return {
    id,
    parentId,
    assessmentFileId: match.params.assessmentFileId,
    contributionId: action && action.action_object && action.action_object.id,
    name:
      action &&
      action.action_object &&
      action.action_object.account &&
      action.action_object.account.full_name,
    avatar:
      action &&
      action.action_object &&
      action.action_object.account &&
      action.action_object.account.avatar,
    content: action && action.action_object && action.action_object.content,
    timestamp:
      action && action.action_object && action.action_object.created_at,
    canDelete:
      action &&
      action.action_object &&
      action.action_object.policy &&
      action.action_object.policy.can_delete,
    edited: action && action.action_object && action.action_object.edited_at
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(ActionCommentReply)
)
